import { React } from 'react'
import { Box, Typography, Icon, Card, Divider } from '@mui/material'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'

const PreviewTable = ({ staffData }) => {
  let errors = staffData?.errors
  return (
    <>
      {staffData?.errors_count === 0 ? (
        <AdxEmptyStateV2
          icon={<Icon sx={{ color: 'alternate.main', fontSize: 50 }}>check_circle</Icon>}
          title="All clear."
          subtitle="No errors found! You can proceed by clicking the button below."
        />
      ) : (
        <Box
          sx={{
            maxHeight: 'calc(100vh - 350px)',
            width: 1,
            overflowY: 'auto',
          }}
          className="scrollbar"
        >
          {errors.length !== 0 &&
            errors?.map((item, index) => {
              return (
                <>
                  <Box
                    py={2}
                    pl={3}
                    key={index}
                    display={'flex'}
                    alignItems={'center'}
                    sx={{ borderTop: index > 0 && 1, borderColor: 'gray-line.main' }}
                  >
                    <Box
                      sx={{ minWidth: '150px' }}
                      width={1 / 8}
                      display={'flex'}
                      flexDirection={'row'}
                      alignItems={'center'}
                    >
                      <Icon sx={{ color: 'error.main', mr: 1 }}>error</Icon>

                      <Typography align="center" variant="subtitle1" color="dark-gray-text.main">
                        {item.staff_id}
                      </Typography>
                    </Box>

                    <Box sx={{ minWidth: '150px' }} width={1 / 6}>
                      <Typography variant="subtitle1" color="dark-gray-text.main">
                        {item.staff_name}
                      </Typography>
                    </Box>

                    <Box sx={{ minWidth: '150px', pl: 4 }}>
                      <Typography variant="subtitle1" color="error.main">
                        {item.errors}
                      </Typography>
                    </Box>
                  </Box>
                </>
              )
            })}
        </Box>
      )}
    </>
  )
}

export default PreviewTable
